import { handleRequest } from "../utilities/requestHandler";

export const duplicateUser = (userId) =>
    handleRequest("post", "/users/duplicate", { userId });